import {
    Dropdown,
    Pagination,
    Row,
    Space,
    Spin,
    Table,
    Tag,
    theme,
    Typography,
} from 'antd'
import React, { useEffect } from 'react'
import ProfileAvatar from '../../../candidate/components/profil-avatar'
import { useDispatch, useSelector } from 'react-redux'
import { getAllTaskLog, setPaginationPage } from '../../store/taskLog.slice'
import { DOMAIN_LIST } from '../../../../constants/roles'

const { Text } = Typography

const TaskLogListTable = () => {
    const { useToken } = theme
    const { token } = useToken()
    const { taskLogs, isLoading, pagination, filters, search, workSpaceId } =
        useSelector((state) => state.taskLogSlice)
    const dispatch = useDispatch()
    const currentDomain = window.location.hostname;
    const isDomainAllowed = DOMAIN_LIST.includes(currentDomain);

    useEffect(() => {

        if (filters?.end != null && workSpaceId != null && isDomainAllowed) {
            dispatch(
                getAllTaskLog({
                    search: search,
                    skip: pagination.page,
                    limit: pagination.limit,
                    filter: filters,
                    workspaceId: workSpaceId,
                })
            )
        }



    }, [
        // pagination.page,
        // pagination.limit,
        search,
        dispatch,
        filters.end,
        workSpaceId,
    ])
    useEffect(() => {
        if (!isDomainAllowed && filters?.end != null) {
            dispatch(
                getAllTaskLog({
                    search: search,
                    skip: pagination.page,
                    limit: pagination.limit,
                    filter: filters,
                    // workspaceId: workSpaceId,
                })
            )
        }
    }, [filters.end, search])

    const handlePageChange = (page, pageSize) => {
        dispatch(setPaginationPage({ page: page, limit: pageSize }))
    }

    const formatTimeFromMilliseconds = (ms) => {
        if (!ms || isNaN(ms)) return '-'

        const totalSeconds = Math.floor(ms / 1000)
        const totalMinutes = Math.floor(totalSeconds / 60)
        const totalHours = Math.floor(totalMinutes / 60)

        const weeks = Math.floor(totalHours / 168)
        const days = Math.floor((totalHours % 168) / 24)
        const hours = totalHours % 24
        const minutes = totalMinutes % 60
        const seconds = totalSeconds % 60

        let result = ''
        if (weeks > 0) result += `${weeks}w `
        if (days > 0) result += `${days}d `
        if (hours > 0) result += `${hours}h `
        if (minutes > 0) result += `${minutes}m `
        if (seconds > 0 || result === '') result += `${seconds}s`

        return result.trim()
    }
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, item) => (
                <Space>
                    <ProfileAvatar
                        profilePicture={item?.profilePicture}
                        name={text}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Text>{text ? text : '-'} </Text>
                        <Text>{item.email ? item.email : '-'} </Text>
                    </div>
                </Space>
            ),
        },
        {
            title: 'Project',
            dataIndex: 'project',
            key: 'project',
            render: (text, item) => (
                <Space>
                    <Tag color="cyan" style={{ cursor: "auto" }}>
                        {' '}
                        <Text>{text?.name ? text.name : '-'} </Text>
                    </Tag>
                </Space>
            ),
        },
        {
            title: 'Task',
            dataIndex: 'task',
            key: 'task',
            render: (text, item) => (
                <Space>
                    <Text>{text?.title ? text?.title : '-'} </Text>
                </Space>
            ),
        },
        {
            title: 'Time',
            dataIndex: 'totalLog',
            key: 'totalLog',
            render: (text, item) => (
                <Space>
                    <Text>
                        {text ? formatTimeFromMilliseconds(text) : '-'}{' '}
                    </Text>
                </Space>
            ),
        },
    ]

    return (
        <div>
            <Spin spinning={isLoading ? true : false}>
                <Table
                    columns={columns}
                    dataSource={taskLogs}
                    scroll={{
                        x: 'scroll',
                    }}
                    pagination={false}
                    rootClassName="tableGlobal"
                    style={{
                        borderRadius: '16px',
                        marginTop: '25px',
                    }}
                />
                {/* <Pagination
                    current={pagination.page}
                    pageSize={pagination.limit}
                    total={pagination.totalCount}
                    onChange={handlePageChange}
                    style={{ marginTop: '16px', textAlign: 'right' }}
                /> */}
                {/* {taskLogs?.length > 0 && (
                    <Row
                        justify={'end'}
                        align={'middle'}
                        style={{
                            border: `2px solid ${token.colorPalette.baseColor.quaternary}`,
                            padding: '15px 20px',
                            borderRadius: '0px 0px 8px 8px',
                        }}
                    >
                        <Text>
                            {pagination.page} - {pagination.totalPages} of{' '}
                            {pagination.totalCount}
                        </Text>
                        <Pagination
                            current={pagination.page}
                            pageSize={pagination.limit}
                            total={pagination.totalCount}
                            pageSizeOptions={[2, 10, 20, 50, 100]}
                            showSizeChanger
                            onChange={
                                handlePageChange
                            }
                        />
                    </Row>
                )} */}
            </Spin>
        </div>
    )
}

export default TaskLogListTable
